import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authService.me()
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authService.login({ email, password });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const isSupport = ['superadmin', 'admin', 'support_l1', 'support_l2', 'developer'].includes(user?.role);
  const isAdmin = ['superadmin', 'admin'].includes(user?.role);
  // Business Support vertical (superadmin sees both verticals, per Task 11).
  const isBusinessSupport = ['superadmin', 'business_support_lead', 'business_support_viewer'].includes(user?.role);
  const isBusinessLead = ['superadmin', 'business_support_lead'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isSupport, isAdmin, isBusinessSupport, isBusinessLead }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
